<template>
  <div class="tutorial-page">
    <div class="page-header">
      <button class="nav-button" @click="goBack">返回</button>
      <div class="header-title">
        <span class="header-kicker">Usage Guide</span>
        <h1>苹果定位修改教程</h1>
      </div>
      <div class="header-space"></div>
    </div>

    <div class="tutorial-shell">
      <div class="intro-card">
        <p>
          按照下面顺序操作会更稳：<span class="danger-text">先安装描述文件并信任证书</span>，再连接 VPN，最后进入地图页锁定位置并刷新定位服务。
        </p>
      </div>

      <div class="guide-card" ref="part1">
        <div class="card-title">
          <span class="section-tag">第一部分</span>
          <h2>VPN 安装连接教程</h2>
        </div>

        <div class="guide-item">
          <span class="guide-no">1</span>
          <div class="guide-main">
            <h3>获取卡密</h3>
            <p>先获取有效卡密，联系 QQ 群：1098075883。</p>
          </div>
        </div>

        <div class="guide-item">
          <span class="guide-no">2</span>
          <div class="guide-main">
            <h3>下载并安装描述文件</h3>
            <p>
              回到首页点击“下载配置文件”，下载成功后，在 iPhone 中打开
              <span class="highlight-text">设置 > 通用 > VPN 与设备管理</span>，找到描述文件
              <span class="highlight-text">(G-lin独享隧道)</span> 并点击安装。
            </p>
            <p>安装过程中按提示输入手机锁屏密码并确认安装。</p>
          </div>
        </div>

        <div class="guide-item">
          <span class="guide-no">3</span>
          <div class="guide-main">
            <h3>信任 Root 证书</h3>
            <p>
              安装完成后，进入
              <span class="highlight-text">设置 > 通用 > 关于本机 > 证书信任设置</span>，找到
              <span class="highlight-text">G-lin Root CA</span> 并打开信任开关。
            </p>
            <div class="warn-box">
              <strong>重要</strong>
              <p>这一步必须做，否则 VPN 大概率无法连接成功。</p>
            </div>
          </div>
        </div>

        <div class="guide-item">
          <span class="guide-no">4</span>
          <div class="guide-main">
            <h3>连接 VPN</h3>
            <p>
              返回 <span class="highlight-text">设置 > VPN</span>，找到
              <span class="highlight-text">(G-lin独享隧道)</span> 并连接。
            </p>
            <p><span class="danger-text">确认 VPN 状态已连接</span> 后，再回到系统继续下一步。</p>
          </div>
        </div>
      </div>

      <div class="guide-card" ref="part2">
        <div class="card-title">
          <span class="section-tag">第二部分</span>
          <h2>定位修改教程</h2>
        </div>

        <div class="guide-item">
          <span class="guide-no">1</span>
          <div class="guide-main">
            <h3>进入地图并锁定位置</h3>
            <p>确认 VPN 已连接后，返回首页点击“进入系统”，进入地图页。</p>
            <p>搜索目标地点或拖动地图，确认位置无误后点击“锁定位置”。</p>
          </div>
        </div>

        <div class="guide-item">
          <span class="guide-no">2</span>
          <div class="guide-main">
            <h3>刷新定位服务</h3>
            <p>
              锁定成功后，进入
              <span class="highlight-text">设置 > 隐私与安全性 > 定位服务</span>，先关闭再重新打开定位服务。
            </p>
            <div class="warn-box soft">
              <strong>提示</strong>
              <p>关闭定位后停 3-5 秒，然后再打开定位服务，即可刷新定位。</p>
            </div>
          </div>
        </div>

        <div class="guide-item">
          <span class="guide-no">3</span>
          <div class="guide-main">
            <h3>验证定位是否生效</h3>
            <p>打开苹果地图、高德地图、百度地图等应用，检查当前位置是否已经切换到目标位置。</p>
          </div>
        </div>

        <div class="guide-item">
          <span class="guide-no">4</span>
          <div class="guide-main">
            <h3>恢复原始定位</h3>
            <p>断开 VPN，并重新刷新定位服务，即可逐步恢复原始位置。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCardSession } from './card-session'

export default {
  name: 'IphonLocalTutorial',
  mounted() {
    this.scrollToSection()
  },
  watch: {
    '$route.query.section'() {
      this.$nextTick(() => {
        this.scrollToSection()
      })
    },
  },
  methods: {
    goBack() {
      if (getCardSession()) {
        this.$router.push('/iphon-seting')
        return
      }
      this.$router.push('/iphon-seting/auth')
    },
    scrollToSection() {
      const section = this.$route.query.section
      if (!section) {
        window.scrollTo(0, 0)
        return
      }
      const target = this.$refs[section]
      if (!target || !target.getBoundingClientRect) {
        return
      }
      const rect = target.getBoundingClientRect()
      const offsetTop = window.pageYOffset + rect.top - 18
      window.scrollTo({
        top: Math.max(offsetTop, 0),
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style scoped>
.tutorial-page {
  min-height: 100vh;
  padding: 0 12px 24px;
  background:
    radial-gradient(circle at top left, rgba(151, 220, 255, 0.22), transparent 34%),
    linear-gradient(180deg, #f4f9ff 0%, #f9fbff 46%, #f2f6fb 100%);
}

.tutorial-shell {
  display: grid;
  gap: 12px;
  padding-top: 84px;
}

.page-header,
.intro-card,
.guide-card {
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.82);
  box-shadow: 0 18px 40px rgba(87, 122, 163, 0.12);
  backdrop-filter: blur(14px);
  border-radius: 24px;
}

.page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: grid;
  grid-template-columns: 64px 1fr 64px;
  align-items: center;
  padding: 14px 12px;
  margin: 0 12px;
}

.page-header::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 12px;
  right: 12px;
  height: 8px;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(4px);
}

.nav-button {
  height: 38px;
  border: none;
  border-radius: 999px;
  background: #edf6ff;
  color: #3b82f6;
  font-size: 13px;
  font-weight: 600;
}

.header-title {
  text-align: center;
}

.header-kicker {
  display: block;
  color: #7b8da1;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.header-title h1 {
  margin: 4px 0 0;
  color: #0f172a;
  font-size: 22px;
  letter-spacing: -0.03em;
}

.header-space {
  height: 1px;
}

.intro-card {
  padding: 16px;
}

.intro-card p,
.guide-main p {
  margin: 0;
  color: #56697c;
  font-size: 14px;
  line-height: 1.75;
}

.guide-card {
  padding: 18px 16px;
}

.card-title {
  margin-bottom: 14px;
}

.section-tag {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  background: #eaf4ff;
  color: #3b82f6;
  font-size: 12px;
  font-weight: 600;
}

.card-title h2 {
  margin: 10px 0 0;
  color: #0f172a;
  font-size: 22px;
}

.guide-item {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid rgba(206, 222, 238, 0.54);
}

.guide-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.guide-no {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: linear-gradient(135deg, #82c9ff, #98d8ff);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  box-shadow: 0 10px 22px rgba(152, 216, 255, 0.28);
}

.guide-main h3 {
  margin: 0 0 6px;
  color: #0f172a;
  font-size: 17px;
}

.guide-main p + p {
  margin-top: 6px;
}

.highlight-text {
  color: #1d4ed8;
  font-weight: 600;
}

.danger-text {
  color: #ef4444;
  font-weight: 600;
}

.warn-box {
  margin-top: 10px;
  padding: 12px 14px;
  border-radius: 16px;
  background: #fff1f2;
  color: #b91c1c;
}

.warn-box.soft {
  background: #fff8e8;
  color: #a16207;
}

.warn-box strong {
  display: block;
  margin-bottom: 4px;
}

@media (max-width: 480px) {
  .page-header {
    grid-template-columns: 56px 1fr 56px;
  }

  .header-title h1,
  .card-title h2 {
    font-size: 20px;
  }
}
</style>
